export const userIdRegex = /auth0\|\w{24}/gi;
